// Vendored: matches stored answers by option id with text fallback and shows
// orphaned answers (see Components/VendoredExam/VENDORED.md). Chip was unused.
import { TestAnswer } from '@Components/VendoredExam'
import { useTranslation } from 'react-i18next'
import React, { FC } from 'react'
import { Box, FlexLayout, Typography } from '@eduact/ed-system'
import styled from 'styled-components'
import { Color } from '@eduact/student-theme'
import { Text as FeedbackTitle } from '@eduact/ed-components/TestSummary/OrderingAnswer/OrderingAnswer'
import { FeedbacktWrapper } from '@eduact/ed-components/TestSummary/GapAnswer/GapAnswer'
import stampAutoDir from '@Utilities/StampAutoDir'

type Props = {
	data: Attempt | undefined
}

const Answers: FC<Props> = ({ data }) => {
	const [t] = useTranslation('test')
	const renderType = (type: string) => {
		switch (type) {
			case 'mrq':
				return t('mrq')
			case 'mcq':
				return t('mcq')
			case 'gap':
				return t('gap')
			case 'ordering':
				return t('ordering')
			case 'essay':
				return t('Essay')
			default:
				return
		}
	}

	return (
		<div>
			{data?.attempt.questions.map((question, index) => {
				return (
					<TestAnswer
						type={renderType(question.type)}
						questionNum={t('questionNum')}
						points={t('points')}
						status={data.attempt.status}
						question={question}
						test={data?.attempt.test as any}
						extraContent={({ showCorrectAnswer, question }) => {
							// Per-ANSWER instructor feedback — the grader's note on an essay
							// answer, distinct from the question-level feedback the vendored
							// EssayAnswer renders. Only essays are hand-graded, so only they
							// can carry one.
							const answerFeedback: unknown = question.type === 'essay' ? question?.answer?.feedback : undefined
							const feedbackBlock =
								typeof answerFeedback === 'string' && answerFeedback.trim() !== '' ? (
									<>
										<FeedbackTitle>{t('feedback')}</FeedbackTitle>
										<FeedbacktWrapper dangerouslySetInnerHTML={{ __html: stampAutoDir(answerFeedback) }} />
									</>
								) : null
							if (question.type !== 'mrq' || !showCorrectAnswer) return feedbackBlock
							return (
								<div>
									<LegendWrapper
										flexWrap={'wrap'}
										width={{ sm: '60%', md: '100%' }}
										margin={'0 auto'}
										justifyContent={'center'}
									>
										<LegendCircle color="#00d66b19">{t('correct')}</LegendCircle>
										<LegendCircle color="#ffd5cc">{t('wrong')}</LegendCircle>
										<LegendCircle color="#00a05056">{t('correct_not_answered')}</LegendCircle>
									</LegendWrapper>
									{feedbackBlock}
								</div>
							)
						}}
						index={index}
						notAnswered={t('notAnswered')}
					/>
				)
			})}
		</div>
	)
}
export default Answers

type LegendCircleProps = {
	color: Color | (string & {})
}

const LegendWrapper = styled(FlexLayout)`
	background-color: ${p => p.theme.colors.light};
	gap: 1rem;
`
const LegendCircle = styled.span<LegendCircleProps>`
	padding: 0.2rem 0.5rem;
	border-radius: 12px;
	font-size: 9px;

	${({ theme }) => `${theme.mediaQueries.medium}{
		font-size: 12px;
		padding: 0.5rem 1rem;
		
	}`}
	border: 0.5px solid #000;
	background-color: ${p => p.color};
	font-size: 12px;
`
